/* Consent is stored only through Shopify's Customer Privacy API.
   No analytics/advertising tag is loaded by this script. Shopify regional
   consent settings and any external apps must also be configured correctly. */
(() => {
  const panel = document.getElementById('cb-cookie');
  if (!panel) return;
  const status = panel.querySelector('[role=status]');
  let api, loading, returnFocus, explicitOpen = false;
  const controls = [...panel.querySelectorAll('[data-consent]')];
  const keys = ['preferences', 'analytics', 'marketing'];
  const valid = consent => keys.every(key => ['yes', 'no'].includes(consent[key]));
  function error(message) { status.textContent = message; }
  function show(advanced = false) {
    panel.hidden = false;
    panel.querySelector('.cb-cookie-options').hidden = !advanced;
    panel.querySelector('[data-consent=save]').hidden = !advanced;
    panel.querySelector('[data-consent=customize]').hidden = advanced;
    const consent = api?.currentVisitorConsent?.() || {};
    for (const key of keys) panel.querySelector(`[name=${key}]`).checked = consent[key] === 'yes';
    panel.querySelector('[data-cb-cookie-close]').hidden = !valid(consent);
    if (explicitOpen) panel.querySelector(advanced ? 'input' : '[data-consent]').focus();
  }
  async function getAPI() {
    if (api) return api;
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let attempts = 0;
      const load = () => {
        if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
        if (window.Shopify?.loadFeatures) {
          const timer = setTimeout(() => reject(Error('timeout')), 10000);
          window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], e => {
            clearTimeout(timer);
            if (e || !window.Shopify.customerPrivacy) reject(Error('unavailable'));
            else resolve(window.Shopify.customerPrivacy);
          });
        } else if (++attempts < 60) setTimeout(load, 150);
        else reject(Error('unavailable'));
      };
      load();
    }).then(value => { api = value; return value; }).finally(() => { loading = null; });
    return loading;
  }
  async function initialize() {
    if (panel.dataset.mode === 'shopify') return;
    try {
      const privacy = await getAPI();
      const consent = privacy.currentVisitorConsent();
      if (privacy.shouldShowBanner() || (panel.dataset.worldwide === 'true' && !valid(consent))) show();
    } catch {
      show();
      error('Die Datenschutzeinstellungen konnten nicht geladen werden. Bitte versuchen Sie Ihre Auswahl erneut. Es wurde keine Einwilligung gespeichert.');
    }
  }
  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-cb-cookie-open]');
    if (!opener) return;
    returnFocus = opener; explicitOpen = true;
    if (panel.dataset.mode === 'shopify') {
      try {
        if (window.privacyBanner?.showPreferences) await window.privacyBanner.showPreferences();
        else if (window.Shopify?.privacyBanner?.showPreferences) await window.Shopify.privacyBanner.showPreferences();
        else { await getAPI(); show(true); error('Die Shopify-Banneransicht ist nicht verfügbar. Sie können Ihre Auswahl hier aktualisieren.'); }
      } catch { show(true); error('Einstellungen derzeit nicht erreichbar. Bitte erneut versuchen.'); }
    } else { try { await getAPI(); error(''); } catch { error('Verbindung derzeit nicht verfügbar. Bitte Ihre Auswahl erneut versuchen.'); } show(true); }
  });
  panel.querySelector('[data-cb-cookie-close]').addEventListener('click', () => { panel.hidden = true; returnFocus?.focus(); });
  for (const button of controls) button.addEventListener('click', async () => {
    const action = button.dataset.consent;
    if (action === 'customize') { show(true); return; }
    const desired = Object.fromEntries(keys.map(key => [key, action === 'accept' || (action === 'save' && panel.querySelector(`[name=${key}]`).checked)]));
    controls.forEach(x => { x.disabled = true; }); error('Auswahl wird gespeichert …');
    try {
      const privacy = await getAPI();
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(Error('timeout')), 10000);
        privacy.setTrackingConsent(desired, result => { clearTimeout(timer); result?.error ? reject(Error('save')) : resolve(); });
      });
      const saved = privacy.currentVisitorConsent();
      if (!keys.every(key => saved[key] === (desired[key] ? 'yes' : 'no'))) throw Error('not confirmed');
      panel.hidden = true; error(''); returnFocus?.focus();
      document.dispatchEvent(new CustomEvent('canbrace:consent-saved', {detail: desired}));
    } catch { error('Ihre Auswahl wurde nicht bestätigt. Bitte versuchen Sie es erneut.'); }
    finally { controls.forEach(x => { x.disabled = false; }); }
  });
  initialize();
})();
